import css from './index.module.scss';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';

export default function E() {
    const { useLang, gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const arr = ['mx'].includes(locale)
        ? ['product_ps_delta_delta_2', 'product_ps_delta_delta_2_max', 'product_ps_river_river_256']
        : ['au', 'za', 'sa'].includes(locale)
        ? ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_pro_720']
        : ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_river_river_256'];
    const { t } = useLang('xstream');
    const otherProducts = getDetaileMoreProducts(gloproductlist, arr);

    return (
        <div className={`xstream_E ${css.xstream_E}`}>
            <div className="section-6">
                <div className="text-wrapper">
                    <div className="title">{t('section_6_title')}</div>
                    <div className="desc">{t('section_6_desc')}</div>
                </div>
                <OtherList theme="black" data={otherProducts} />
            </div>
        </div>
    );
}
